export default "__VITE_PUBLIC_ASSET__ee32c5f2__"